import * as React from "react"
import TopNav from "@kiwicom/nitro/lib/components/TopNav"
// @ts-expect-error: Flow to TS migration.
import { renderRoutes, Route, RouterProps } from "react-router-config"
// @ts-expect-error: Flow to TS migration.
import { connect, Connector } from "react-redux"
import DebugModal from "@kiwicom/frontend-app/scripts/modules/Debug/DebugModal"
import SubscriptionModal from "@kiwicom/frontend-app/scripts/modules/Auth/SubscriptionModal"
import NotFound from "@kiwicom/frontend-common/components/NotFound/NotFound"
import {
  matchedRoutesSelector,
  paramsFromLastMatchedRouteSelector,
} from "@kiwicom/frontend-common/components/UpdateRoute/services/selector"
import { queryFromReactRouterPropsSelector } from "@kiwicom/frontend-common/services/query/selector"
import { logoClick } from "@kiwicom/frontend-common/utils/nitroSideEffects"
import MainView from "@kiwicom/frontend-common/components/MainView/MainView"
import changeLanguage from "@kiwicom/frontend-common/utils/changeLanguage"
// NavBar imports
import checkDebugEnabled from "@kiwicom/frontend-common/utils/checkDebugEnabled"
import useNavbarHiddenElements from "@kiwicom/frontend-common/utils/useNavbarHiddenElements"
import { useIntl } from "@kiwicom/nitro/lib/services/intl/context"
import { openNewTab } from "@kiwicom/frontend-common/services/utils/tabUtils"
import { useFeature } from "@kiwicom/darwin"
import HeaderData from "../browser/HeaderData"
import { brandLanguageSelector } from "@kiwicom/frontend-common/services/intl/translateSelector"
import { topic } from "../services/tracking/businessEvents"

type Props = RouterProps & {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  query: {
    [key: string]: string
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  params: {
    [key: string]: string
  }
  matchedRoutes: Route[]
}

const Root = ({ route, query, matchedRoutes, params, brandLanguage }: Props) => {
  const navbarHiddenElements = useNavbarHiddenElements()
  const { language } = useIntl()
  const isMarketplaceEnabled = useFeature("MARKETPLACE_ENABLED")

  if (matchedRoutes[matchedRoutes.length - 1].status === 404) {
    return <NotFound routes={matchedRoutes} params={params} query={query} />
  }

  function handleOpenHelp() {
    openNewTab(`/${language.id}/help/`)
  }

  return (
    <MainView
      module="mmb"
      routes={matchedRoutes}
      params={params}
      query={query}
      navbar={
        <TopNav
          brandLanguage={brandLanguage}
          subscriptionModalContent={<SubscriptionModal />}
          debugModalContent={Boolean(checkDebugEnabled()) && <DebugModal />}
          onOpenHelp={handleOpenHelp}
          onSaveRegionalSettings={({ languageId }) => changeLanguage(languageId)}
          onLogoClick={logoClick}
          modalId="modals"
          hide={navbarHiddenElements}
          pubSubTopic={topic}
          showMarketplaceLink={isMarketplaceEnabled}
        />
      }
    >
      <HeaderData />
      <div id="content-wrapper">{renderRoutes(route.routes)}</div>
    </MainView>
  )
}

const connector: Connector<RouterProps, Props> = connect((state, props) => ({
  matchedRoutes: matchedRoutesSelector(props),
  params: paramsFromLastMatchedRouteSelector(props),
  query: queryFromReactRouterPropsSelector(props),
  brandLanguage: brandLanguageSelector(state),
}))

export default connector(Root)
